var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._m(0),
      _c("dv-border-box-12", [
        _c("div", { ref: "chart", staticClass: "chart-small" }),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", { staticClass: "title" }, [
      _c("i", { staticClass: "el-icon-data-analysis font-xl text-v" }),
      _c("span", { staticClass: "text-v ml-1x" }, [_vm._v("当前异常类型分布")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }